import React, { useState } from 'react';

const LOGO_URL = '/ivilotid-logo.png';

type BrandMarkProps = {
  inverted?: boolean;
  compact?: boolean;
};

export function BrandMark({ inverted = false, compact = false }: BrandMarkProps) {
  const [imageFailed, setImageFailed] = useState(false);
  const logoHeight = compact ? 'h-14 sm:h-16' : 'h-11 sm:h-12';

  return (
    <div className={`inline-flex min-w-0 items-center ${compact ? 'gap-0' : 'gap-2.5'}`}>
      {imageFailed ? (
        <span
          className={`font-display text-lg font-bold tracking-[-.05em] ${inverted ? 'text-white' : 'text-[#0B1120]'}`}
        >
          iVilotid
        </span>
      ) : (
        <img
          src={LOGO_URL}
          alt="iVilotid"
          onError={() => setImageFailed(true)}
          className={`w-auto max-w-[260px] object-contain ${logoHeight}`}
        />
      )}
      {!compact ? (
        <span className="hidden border-l border-current/30 pl-2.5 text-xs font-bold uppercase tracking-[0.1em] text-current/80 sm:block">
          Digital vilotid för svensk taxi
        </span>
      ) : null}
    </div>
  );
}
